import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import type { Ubicacion } from '../../stores/ubicaciones/ubicacion';
import type {
  ActualizarUbicacion,
  RegistrarUbicacion
} from '../../stores/ubicaciones/ubicaciones.store';
import { useUIStore } from '../../stores/ui/ui.store';
import type { CommonEntityFormProps } from '../../utils/common-entity-form-props';
import { getLengthOrErrorText } from '../../utils/get-length-or-error-text';
import AppTextField from '../ui/AppTextField';
import EditForm from '../ui/EditForm';

const validationSchema = yup.object({
  id: yup.number(),
  nombre: yup.string().required('El nombre es requerido')
});

type UbicacionFormProps = {
  ubicacion?: Ubicacion;
  onSave:
    | ((values: ActualizarUbicacion) => Promise<void>)
    | ((values: RegistrarUbicacion) => Promise<boolean>);
} & CommonEntityFormProps;

const UbicacionForm = ({
  ubicacion,
  esAgregar,
  onSave,
  onDelete,
  onActivate
}: UbicacionFormProps) => {
  const esEditar = !esAgregar;
  const activo = esAgregar || ubicacion?.activa === true;
  const inactivo = !activo;
  const status = activo ? 'ACTIVO' : 'INACTIVO';
  const { loading } = useUIStore((state) => state);
  const initialValues = {
    id: ubicacion?.id ?? 0,
    nombre: ubicacion?.nombre ?? ''
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const shouldReset = await onSave(values);
      if (shouldReset) {
        formik.resetForm();
      }
    },
    enableReinitialize: true
  });

  const reset = () => formik.resetForm({ values: initialValues });

  return (
    <EditForm
      module="ubicaciones"
      title="Ubicaciones"
      readonly={!activo}
      returnLink="/ubicaciones"
      loading={loading}
      showActivate={false}
      showDelete={esEditar}
      onSave={formik.handleSubmit}
      onClear={reset}
      onDelete={onDelete}
      onActivate={onActivate}
    >
      <Grid>
        <Grid container spacing={2}>
          <Grid>
            <AppTextField
              name="id"
              label="Código"
              placeholder="Código"
              value={formik.values.id}
              disabled={true}
            />
          </Grid>
          <Grid size="grow">
            <AppTextField
              name="nombre"
              label="Nombre"
              placeholder="Nombre"
              maxLength={40}
              disabled={loading || inactivo}
              value={formik.values.nombre}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={getLengthOrErrorText(
                formik.touched.nombre ? formik.errors.nombre : '',
                formik.values.nombre.length,
                40
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 3 }}>
        <AppTextField label="Status" value={status} disabled={true} />
      </Grid>
    </EditForm>
  );
};

export default UbicacionForm;
